import React, { useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { BLOG } from './queries';
import {
  BlogContainer,
  ContentContainer
} from './elements';
import DataState from '../DataState';
import { MainContainer } from '../../elements';
import SubNav from './SubNav';
import { View, Text, Pressable } from 'react-native';
import { useNavigate } from 'react-router-dom';
import Modal from 'app/src/elements/Modal';
import NewBlog from './new';
import Card from './Card';
import Tags from './ManageTags';
import AuthContext from '../../contexts/AuthContext';

const Blog = () => {
  const { id } = useParams();
  const { hasPolicy } = useContext(AuthContext);
  const navigate = useNavigate();
  const [showAddModal, setShowAddModal] = useState();
  const [showManageTagsModal, setShowManageTagsModal] = useState();

  const { loading, data, refetch } = useQuery(
    BLOG, { variables: { id: id } }
  );

  if(loading) return <DataState.Loading />;

  return (
    <MainContainer>
      <SubNav refetch={refetch}>
        <View style={{display: 'flex', flexDirection: 'row', marginTop: '-10px'}}>
          <>
            <Pressable
              onPress={() => navigate('/blog')}
            >
              <Text style={{marginTop: '10px'}}>
                Back to Blog
              </Text>
            </Pressable>
            {hasPolicy({type: 'Blog', action: 'create'}) ?
              <Pressable
                onPress={() => setShowAddModal(true)}
                style={{marginLeft: '20px'}}
              >
                <Text style={{marginTop: '10px'}}>
                  +Add Blog
                </Text>
              </Pressable> :
              null
            }
            {hasPolicy({type: 'Blog', action: 'edit'}) ?
              <Pressable
                onPress={() => setShowManageTagsModal(true)}
                style={{marginLeft: '20px'}}
              >
                <Text style={{marginTop: '10px'}}>
                  Manage Tags
                </Text>
              </Pressable> :
                null
            }
          </>
        </View>
      </SubNav>
      <BlogContainer padding='2% 5%' style={{justifyContent: 'space-around'}}>
        <ContentContainer fromShow={true}>
          <Card blog={data?.blog} fromShow={true} />
        </ContentContainer>
      </BlogContainer>
      {showAddModal &&
        <Modal
          showModal
          setShowModal={setShowAddModal}
          modalType="Add Blog"
        >
          <NewBlog
            setShowModal={setShowAddModal}
            refetch={refetch}
          />
        </Modal>
      }

      {showManageTagsModal &&
        <Modal
          showModal
          setShowModal={setShowManageTagsModal}
          modalType="Manage Blog Categories"
        >
          <Tags
            setShowModal={setShowManageTagsModal}
          />
        </Modal>
      }
    </MainContainer>
  )
}

export default Blog;